import { http } from './index'

export interface ResetUserPasswordPayload {
    password: string
    send_to_email: boolean
    email?: string
}

export async function getEmployments() {
    return await http.get<any>(`/api/employments/`)
}

export async function createUser(data:any) {
    return await http.post<any>(`/api/user/`, data)
}

export async function getUser(id:string) {
    return await http.get<any>(`/api/user/${id}/`)
}

export async function getUsersFired(params:any) {
    return await http.get<any>('/api/user/fired/', { params })
}

export async function getUsers(params:any) {
    return await http.get<any>('/api/user/', { params })
}

export async function editUser(data: any, id: string) {
    return await http.patch<any>(`/api/user/${id}/`, data)
}

export async function resetUserPassword(id: string, data: ResetUserPasswordPayload) {
    return await http.post<any>(`/api/user/${id}/reset-password/`, data, {
        suppressGlobalErrorToast: true
    })
}

export async function getEmployment(id:string) {
    return await http.get<any>(`/api/employments/${id}/`)
}

export async function postEmployment(data:any) {
    return await http.post<any>(`/api/employments/`, data)
}

export async function getEmploymentSchedule(id:string, params: any) {
    return await http.get<any>(`/api/employments/${id}/schedule/`, {params})
}

export async function editEmployment(id:string, data: any) {
    return await http.patch<any>(`/api/employments/${id}/`, data)
}
